import React from 'react'
import { object } from 'prop-types'
import { Fieldset } from 'react-gridforms'

import List from './list'

const Container  = ({ data }) => {
  const legend = (
    <span>{data.getIn(['header', 'full_name1'])} <span className="text-muted">({data.getIn(['header', 'id'])})</span></span>
  )
  return (
    <form className="grid-form">
      <Fieldset legend={legend}>
        <List items={data.get('ledger')} />
      </Fieldset>
    </form>
  )
}

Container.propTypes = {
  data: object,
}

export default Container



// WEBPACK FOOTER //
// ./src/containers/Ledger/container.js